import axios from 'axios';
import {
  baseURL,
  INVOICE_CREATE_REQUEST,
  INVOICE_CREATE_SUCCESS,
  INVOICE_CREATE_FAIL,
  INVOICE_LIST_REQUEST,
  INVOICE_LIST_SUCCESS,
  INVOICE_LIST_FAIL,
  INVOICE_LIST_ALL_REQUEST,
  INVOICE_LIST_ALL_SUCCESS,
  INVOICE_LIST_ALL_FAIL,
  INVOICE_UPDATE_REQUEST,INVOICE_UPDATE_SUCCESS,INVOICE_UPDATE_FAIL
} from './types';

// The base URL for your API.
const API_URL = `${baseURL}/api`;


// 1. Get 'getState' from the thunk middleware to access the Redux state.
export const createAppointmentInvoice = (invoiceData) => async (dispatch) => {
  try {
    dispatch({ type: INVOICE_CREATE_REQUEST });

    // 2. Get user login info from the state.
    // NOTE: This path 'userLogin.userInfo' is a common convention. 
    // You MUST adjust it if your user state is stored differently in your root reducer.
    // For example, it might be 'auth.user' or 'login.loginData'.
    const token =localStorage.getItem('token')

    // 3. Create the request configuration with the Authorization header.
    const config = {
      headers: {
        'Content-Type': 'application/json',
        // The token is sent in the 'Authorization' header, prefixed with 'Bearer'.
        'Authorization': `Bearer ${token}`,
      },
    };

    // 4. Make the authenticated API call.
    const { data } = await axios.post(
      `${baseURL}/api/appointmentInvoice/create`, // Using the API_URL constant
      invoiceData,
      config
    );

    dispatch({
      type: INVOICE_CREATE_SUCCESS,
      payload: data,
    });
    
    // We return true on success to make it easy to check the result in the component
    return true;

  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: INVOICE_CREATE_FAIL,
      payload: message,
    });
    
    // Log the error for debugging but don't block the user flow
    // as the main appointment booking was successful.
    console.error("Failed to create invoice:", message);
    return false;
  }
};


// ... imports

export const listDoctorInvoices = () => async (dispatch) => {
    try {
      dispatch({ type: INVOICE_LIST_REQUEST });
  
      const token = localStorage.getItem('token');
      const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  
      if (!loginData?.hospitalID) {
        throw new Error('Doctor ID not found. Please log in again.');
      }
  
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
      
      const requestBody = {
        hospitalID: loginData.hospitalID
      };
  
      const { data } = await axios.post(
        `${baseURL}/api/appointmentInvoice/getall`,
        requestBody,
        config
      );
  
      // --- THIS IS THE FIX ---
      // The array of invoices is inside the 'data' property of the response.
      // We also check if it's an array to be safe.
  
      // OLD (INCORRECT) LINE:
      // payload: data.appointment || data,
  
      // NEW (CORRECT) LINE:
      const invoices = Array.isArray(data.data) ? data.data : [];
  
      dispatch({
        type: INVOICE_LIST_SUCCESS,
        payload: invoices,
      });
  
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
  
      dispatch({
        type: INVOICE_LIST_FAIL,
        payload: message,
      });
    }
  };



  // --- (NEW) Action to fetch ALL invoices for the Admin panel ---
  export const listAllInvoices = (hospitalID) => async (dispatch) => {
    try {
      dispatch({ type: INVOICE_LIST_ALL_REQUEST });
  
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
      
      const { data } = await axios.post(
        `${baseURL}/api/appointmentInvoice/getall`,
        {hospitalID},
        config
      );
  
      const invoices = Array.isArray(data.data) ? data.data : [];
  
      dispatch({
        type: INVOICE_LIST_ALL_SUCCESS,
        payload: invoices,
      });
      
      return invoices; // ✅ RETURN THE DATA
  
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({
        type: INVOICE_LIST_ALL_FAIL,
        payload: message,
      });
      return []; // ✅ RETURN EMPTY ARRAY ON ERROR
    }
  };





  export const getInvoiceByTid = (TransactionId) => async (dispatch) => {
    try {
      dispatch({ type: INVOICE_LIST_ALL_REQUEST });
  
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
      
      const { data } = await axios.post(
        `${baseURL}/api/appointmentInvoice/getall`,
        {TransactionId},
        config
      );
  
      const invoices = Array.isArray(data.data) ? data.data : [];
  
      dispatch({
        type: INVOICE_LIST_ALL_SUCCESS,
        payload: invoices,
      });
      
      return invoices; // ✅ RETURN THE DATA
  
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({
        type: INVOICE_LIST_ALL_FAIL,
        payload: message,
      });
      return []; // ✅ RETURN EMPTY ARRAY ON ERROR
    }
  };

// ... (imports and other actions remain the same) ...

export const updateInvoice = (invoiceId, updateData) => async (dispatch) => {
  try {
    dispatch({ type: INVOICE_UPDATE_REQUEST });

    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    // --- THIS IS THE FIX ---
    // 1. Create a new object for the request body.
    // 2. Spread the updateData ({ TotalAmount, Status }).
    // 3. Add the 'id' field with the invoiceId passed to the function.
    const requestBody = {
      id: invoiceId,
      ...updateData
    };

    // Log the body to confirm it's correct before sending
    console.log('Sending PATCH request to /appointmentInvoice/update with body:', requestBody);

    // 4. Use axios.patch to the correct URL (without the ID in the URL).
    const { data } = await axios.patch(
      `${baseURL}/api/appointmentInvoice/update`,
      requestBody, // Send the complete body with the ID
      config
    );

    dispatch({
      type: INVOICE_UPDATE_SUCCESS,
      // The payload from the backend might be nested. Adjust if necessary.
      // e.g., action.payload.data or action.payload.updatedInvoice
      payload: data.data || data, 
    });
    
    return true; // Indicate success

  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    
    console.error('Failed to update invoice:', message); // Log the specific error

    dispatch({
      type: INVOICE_UPDATE_FAIL,
      payload: message,
    });
    return false; // Indicate failure
  }
};